import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_3 = {
  key: 1,
  class: "card-body p-3"
}
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12 table-responsive" }
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "text-danger fw-bold" }
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = { class: "row mb-2" }
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "row mb-2" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = { class: "row mb-2" }
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "row mb-2" }
const _hoisted_40 = { class: "col-md-9" }
const _hoisted_41 = {
  key: 3,
  class: "row mb-2"
}
const _hoisted_42 = { class: "col-md-9" }
const _hoisted_43 = {
  key: 4,
  class: "row mb-2"
}
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 5,
  class: "row mb-2"
}
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = { class: "text-end" }
const _hoisted_56 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_57 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["title"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = { class: "" }
const _hoisted_64 = { class: "text-danger fw-bold" }
const _hoisted_65 = { class: "row mb-2" }
const _hoisted_66 = { class: "col-md-12" }
const _hoisted_67 = { class: "row mb-2" }
const _hoisted_68 = { class: "col-md-9" }
const _hoisted_69 = { class: "row mb-2" }
const _hoisted_70 = { class: "col-md-9" }
const _hoisted_71 = { class: "row mb-2" }
const _hoisted_72 = { class: "col-md-9" }
const _hoisted_73 = { class: "row mb-2" }
const _hoisted_74 = { class: "col-md-12 text-center" }
const _hoisted_75 = { class: "" }
const _hoisted_76 = { class: "text-danger fw-bold" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12" }
const _hoisted_79 = { class: "row mb-2" }
const _hoisted_80 = { class: "col-md-9" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-12 text-center" }
const _hoisted_83 = { class: "" }
const _hoisted_84 = { class: "text-danger fw-bold" }
const _hoisted_85 = { class: "row mb-2" }
const _hoisted_86 = { class: "col-md-4" }
const _hoisted_87 = { class: "col-md-3" }
const _hoisted_88 = { class: "row mb-2" }
const _hoisted_89 = { class: "col-md-12" }
const _hoisted_90 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_91 = { class: "col-md-12 table-responsive" }
const _hoisted_92 = { class: "table table-sm table-striped table-bordered" }
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = { class: "text-end" }
const _hoisted_95 = { class: "row mb-2" }
const _hoisted_96 = { class: "col-md-12 text-center" }
const _hoisted_97 = { class: "" }
const _hoisted_98 = { class: "text-danger fw-bold" }
const _hoisted_99 = {
  key: 1,
  class: "row"
}
const _hoisted_100 = { class: "col-md-12" }
const _hoisted_101 = {
  key: 0,
  class: "row"
}
const _hoisted_102 = { class: "col-md-12 text-center" }
const _hoisted_103 = { class: "row mt-2" }
const _hoisted_104 = { class: "col-md-12 text-center" }
const _hoisted_105 = { class: "" }
const _hoisted_106 = { class: "text-danger fw-bold" }

import { onMounted, reactive, watch } from "vue";

//servicos
import config from "@/app.config.json";
import * as service from "@/services/clientesContratosService";
import * as mensalidadesService from "@/services/mensalidadesService";
import * as paramsService from "@/services/paramsService";
import { fdata, fdataUS, fdataUSS, f2dec, isoParaData } from "@/utils/funcoes";
import { useAcl } from "vue-simple-acl";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";
import DropdownSimNao from "@/components/Dropdowns/DropdownSimNao.vue";
import DropdownContratosStatus from "@/components/Dropdowns/DropdownContratosStatus.vue";

interface IProps {
  ClienteId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientesContratos',
  props: {
    ClienteId: {}
  },
  setup(__props: any) {


//vue
const acl = useAcl();

//componentes
var props = __props;

var controle = reactive({
  clienteId: props.ClienteId as number | null | undefined,
  itens: [] as service.Contrato[],
  listaStatus: [] as service.ContratoStatus[],
  model: {
    clienteId: props.ClienteId
  } as service.Contrato,
  janela: false,
  janPergunta: false,
  erro: "",
  status: "",

  janParcelas: false,
  contratoParcelas: null as service.Contrato | null,
  parcelas: [] as mensalidadesService.Mensalidade[],
  statusParcelas: "",
  erroParcelas: "",

  parcelaEditando: null as mensalidadesService.Mensalidade | null,
  formParcela: {
    dataVencimento: null,
    valor: 0,
    referente: ""
  } as mensalidadesService.MensalidadeAlterarDto,
  statusEdicaoParcela: "",
  erroEdicaoParcela: "",

  janConfirmaPagamento: false,
  parcelaPagando: null as mensalidadesService.Mensalidade | null,
  statusPagamento: "",
  erroPagamento: "",

  janCancelarContrato: false,
  contratoCancelando: null as service.Contrato | null,
  motivoCancelamento: "",
  statusCancelamento: "",
  erroCancelamento: "",

  janGerarParcelas: false,
  formGerarParcelas: {
    dataInicial: null as string | null,
    dataFinal: null as string | null,
  },
  parcelasSimuladas: [] as service.ParcelaSimulada[],
  statusGerarParcelas: "",
  erroGerarParcelas: "",
})

onMounted(() => {

  buscarItems();

});

watch(() => props.ClienteId, (newValue) => {
  controle.clienteId = newValue;
  controle.model.clienteId = newValue ?? 0;
  buscarItems();
});

async function buscarItems() {

  if (!props.ClienteId) {
    controle.itens = [];
    return;
  }

  controle.status = "Buscando items...";
  controle.erro = "";
  service.obterContratosPorCliente(props.ClienteId)
    .then((r) => {
      controle.itens = r;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function buscarStatus() {

  controle.status = "Buscando status...";
  controle.erro = "";
  service.obterStatus()
    .then((r) => {
      controle.listaStatus = r;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function salvar() {

  controle.status = "Salvando item...";
  controle.erro = "";


  controle.model.clienteId = controle.clienteId ?? 0;

  await service.salvar(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = {
        clienteId: controle.model.clienteId,

      } as service.Contrato;

      buscarItems();
      controle.janela = false;
    })
    .catch((error) => {
      controle.erro = `Erro ao salvar item: ${error}`;
      controle.status = "";
    });
}

function excluir(item: service.Contrato) {
  controle.model = item;
  controle.janPergunta = true;
}

function excluirConfirma() {
  controle.janPergunta = false;
  controle.status = "Excluindo item...";
  controle.erro = "";

  service.excluir(controle.model.contratoId)
    .then(() => {
      controle.status = "";
      controle.model = {
        clienteId: controle.model.clienteId,

      } as service.Contrato;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error.message || error}`;
      controle.status = "";
    });
}

function adicionar() {
  controle.model = {
    clienteId: controle.clienteId,
    statusId: 1,

  }
  controle.janela = true;
}

function verParcelas(item: service.Contrato) {
  controle.contratoParcelas = item;
  controle.parcelaEditando = null;
  controle.janParcelas = true;
  buscarParcelas();
}

function buscarParcelas() {
  if (!controle.contratoParcelas?.contratoId) return;

  controle.statusParcelas = "Buscando parcelas...";
  controle.erroParcelas = "";

  mensalidadesService.obterPorContrato(controle.contratoParcelas.contratoId)
    .then((r) => {
      controle.parcelas = r;
      controle.statusParcelas = "";
    })
    .catch((error) => {
      controle.erroParcelas = `Erro ao buscar parcelas: ${error.message || error}`;
      controle.statusParcelas = "";
    });
}

function editarParcela(parcela: mensalidadesService.Mensalidade) {
  controle.parcelaEditando = parcela;
  controle.formParcela = {
    dataVencimento: parcela.dataVencimento ? fdataUS(parcela.dataVencimento) : null,
    valor: parcela.valor,
    referente: parcela.referente
  };
  controle.erroEdicaoParcela = "";
}

function cancelarEdicaoParcela() {
  controle.parcelaEditando = null;
}

function abrirBoleto(boletoId: number) {
  window.open(`${config.urlApi}/Boletos/Ver/${boletoId}`, '_blank');
}

function confirmarPagamento(item: mensalidadesService.Mensalidade) {
  controle.parcelaPagando = item;
  controle.erroPagamento = "";
  controle.janConfirmaPagamento = true;
}

function pagarConfirmado() {
  if (!controle.parcelaPagando) return;

  controle.statusPagamento = "Registrando pagamento...";
  controle.erroPagamento = "";

  mensalidadesService.pagar(controle.parcelaPagando.id)
    .then(() => {
      controle.statusPagamento = "";
      controle.parcelaPagando = null;
      buscarParcelas();
    })
    .catch((error) => {
      controle.erroPagamento = `Erro ao registrar pagamento: ${error.message || error}`;
      controle.statusPagamento = "";
    });
}

function salvarParcela() {
  if (!controle.parcelaEditando) return;

  controle.statusEdicaoParcela = "Salvando...";
  controle.erroEdicaoParcela = "";

  mensalidadesService.alterar(controle.parcelaEditando.id, controle.formParcela)
    .then(() => {
      controle.statusEdicaoParcela = "";
      controle.parcelaEditando = null;
      buscarParcelas();
    })
    .catch((error) => {
      controle.erroEdicaoParcela = `Erro ao salvar parcela: ${error.message || error}`;
      controle.statusEdicaoParcela = "";
    });
}

function abrirCancelarContrato(item: service.Contrato) {
  controle.contratoCancelando = item;
  controle.motivoCancelamento = "";
  controle.erroCancelamento = "";
  controle.statusCancelamento = "";
  controle.janCancelarContrato = true;
}

function cancelarContratoConfirmado() {
  if (!controle.contratoCancelando) return;

  controle.statusCancelamento = "Cancelando contrato...";
  controle.erroCancelamento = "";

  service.cancelarContrato(controle.contratoCancelando.contratoId, controle.motivoCancelamento || null)
    .then(() => {
      controle.statusCancelamento = "";
      controle.janCancelarContrato = false;
      controle.contratoCancelando = null;
      buscarItems();
    })
    .catch((error) => {
      controle.erroCancelamento = `Erro ao cancelar contrato: ${error.message || error}`;
      controle.statusCancelamento = "";
    });
}

function abrirGerarParcelas() {
  controle.parcelasSimuladas = [];
  controle.erroGerarParcelas = "";
  controle.statusGerarParcelas = "";

  paramsService.obter()
    .then((r) => {
      const dia = r?.[0]?.diaVencimentoBoleto ?? 10;

      const hoje = new Date();
      const inicial = new Date(hoje.getFullYear(), hoje.getMonth() + 1, dia);

      controle.formGerarParcelas.dataInicial = fdataUS(inicial);
    });

  controle.janGerarParcelas = true;
}

watch(() => controle.formGerarParcelas.dataInicial, (novoValor) => {
  if (!novoValor) return;

  const inicial = isoParaData(novoValor);
  if (!inicial) return;

  //12 parcelas ao todo: a informada + mais 11, uma por mes
  const final = new Date(inicial.getFullYear(), inicial.getMonth() + 11, inicial.getDate());
  controle.formGerarParcelas.dataFinal = fdataUS(final);
});

function verParcelasSimuladas() {
  if (!controle.contratoParcelas?.contratoId) return;
  if (!controle.formGerarParcelas.dataInicial || !controle.formGerarParcelas.dataFinal) return;

  controle.statusGerarParcelas = "Calculando...";
  controle.erroGerarParcelas = "";
  controle.parcelasSimuladas = [];

  service.simularParcelas(controle.contratoParcelas.contratoId, controle.formGerarParcelas.dataInicial, controle.formGerarParcelas.dataFinal)
    .then((r) => {
      controle.parcelasSimuladas = r.map((item) => ({ ...item, dataVencimento: fdataUS(item.dataVencimento) }));
      controle.statusGerarParcelas = "";
    })
    .catch((error) => {
      controle.erroGerarParcelas = `Erro ao calcular parcelas: ${error.message || error}`;
      controle.statusGerarParcelas = "";
    });
}

function gerarParcelasConfirmado() {
  if (!controle.contratoParcelas?.contratoId || controle.parcelasSimuladas.length == 0) return;

  controle.statusGerarParcelas = "Gerando parcelas...";
  controle.erroGerarParcelas = "";

  service.gerarParcelas(controle.contratoParcelas.contratoId, controle.parcelasSimuladas)
    .then(() => {
      controle.statusGerarParcelas = "";
      controle.janGerarParcelas = false;
      controle.parcelasSimuladas = [];
      buscarParcelas();
    })
    .catch((error) => {
      controle.erroGerarParcelas = `Erro ao gerar parcelas: ${error.message || error}`;
      controle.statusGerarParcelas = "";
    });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Contratos / Planos")
          ], -1)),
          (!_unref(props).ClienteId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("div", { class: "row mb-2" }, [
                  _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("p", { class: "" }, "Necessário cadastro do cliente")
                  ])
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (adicionar()))
                    }, "Adicionar")
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _cache[38] || (_cache[38] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Contrato"),
                          _createElementVNode("th", null, "Vendedor"),
                          _createElementVNode("th", null, "Plano"),
                          _createElementVNode("th", null, "Status"),
                          _createElementVNode("th", null, "Pré contrato"),
                          _createElementVNode("th", null, "Dt. Inicio"),
                          _createElementVNode("th", null, "Dt. Fim"),
                          _createElementVNode("th", null, "Dt. Assinatura"),
                          _createElementVNode("th", null, "Ações")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_unref(controle).itens.length == 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[31] || (_cache[31] = [
                              _createElementVNode("td", {
                                colspan: "9",
                                class: "text-center"
                              }, "Nenhum registro", -1)
                            ]))]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(controle).itens, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(item.contratoId), 1),
                                _createElementVNode("td", null, _toDisplayString(item.vendedor?.nomeCompleto), 1),
                                _createElementVNode("td", null, _toDisplayString(item.plano?.nome), 1),
                                _createElementVNode("td", null, _toDisplayString(item.status?.descricao), 1),
                                _createElementVNode("td", null, _toDisplayString(item.preContrato), 1),
                                _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataInicio)), 1),
                                _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataFim)), 1),
                                _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataAssinatura)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    class: "me-2",
                                    title: "Ver parcelas",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (verParcelas(item)), ["prevent"])
                                  }, [...(_cache[32] || (_cache[32] = [
                                    _createElementVNode("i", { class: "flaticon-money text-primary fs-5" }, null, -1)
                                  ]))], 8, _hoisted_10),
                                  (_unref(acl).can('supervisor') || _unref(acl).can('admin'))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "",
                                        title: "Alterar registro",
                                        href: "#",
                                        onClick: ($event: any) => {_unref(controle).model = item; _unref(controle).janela = true}
                                      }, [...(_cache[33] || (_cache[33] = [
                                        _createElementVNode("i", { class: "flaticon-edit text-primary fs-5" }, null, -1)
                                      ]))], 8, _hoisted_11))
                                    : _createCommentVNode("", true),
                                  (item.statusId != 3 && (_unref(acl).can('supervisor') || _unref(acl).can('admin')))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: "ms-2",
                                        title: "Cancelar contrato",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (abrirCancelarContrato(item)), ["prevent"])
                                      }, [...(_cache[34] || (_cache[34] = [
                                        _createElementVNode("i", { class: "fa fa-ban text-warning fs-5" }, null, -1)
                                      ]))], 8, _hoisted_12))
                                    : _createCommentVNode("", true),
                                  (_unref(acl).can('supervisor') || _unref(acl).can('admin'))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        class: "ms-2",
                                        title: "Excluir registro",
                                        href: "#",
                                        onClick: ($event: any) => (excluir(item))
                                      }, [...(_cache[35] || (_cache[35] = [
                                        _createElementVNode("i", { class: "flaticon-delete text-danger fs-5" }, null, -1)
                                      ]))], 8, _hoisted_13))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_RouterLink, {
                                    class: "ms-2",
                                    title: "Ver o contrato",
                                    to: { name: 'contratosVer', params: { id: item.contratoId } }
                                  }, {
                                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                      _createElementVNode("i", { class: "flaticon-search text-primary fs-5" }, null, -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"]),
                                  (item.dataAssinatura == null)
                                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                                        key: 3,
                                        class: "ms-2",
                                        title: "Assinar o contrato",
                                        to: { name: 'contratosAssinar', params: { id: item.contratoId } }
                                      }, {
                                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                          _createElementVNode("i", { class: "flaticon-pen text-primary fs-5" }, null, -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, "Registros: " + _toDisplayString(_unref(controle).itens.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(controle).status), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(controle).erro), 1)
                ])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createVNode(MsgBox, {
          id: 'janAddContratos',
          class: "modal-md",
          "data-bs-backdrop": "static",
          exibir: _unref(controle).janela,
          titulo: 'Contrato do ciente',
          onOnFechou: _cache[9] || (_cache[9] = ($event: any) => (_unref(controle).janela = false)),
          "botao-gravar": true,
          "botao-fechar": true,
          onOnGravar: _cache[10] || (_cache[10] = ($event: any) => (salvar()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _cache[40] || (_cache[40] = _createElementVNode("div", { class: "col-md-3" }, " Pré contrato ", -1)),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(DropdownSimNao, {
                  modelValue: _unref(controle).model.preContrato,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).model.preContrato) = $event)),
                  class: "form-select form-select-sm"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model.preContrato == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-3" }, " Vencimento 1º Boleto ", -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      value: _unref(fdataUS)(_unref(controle).model.dataPriParcela)
                    }, null, 8, _hoisted_24)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col-md-3" }, " Plano ", -1)),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(DropdownPlanos, {
                  modelValue: _unref(controle).model.planoId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.planoId) = $event)),
                  class: "form-select form-select-sm",
                  onSelected: _cache[3] || (_cache[3] = (plano) => _unref(controle).model.plano = plano)
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model.planoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col-md-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_RouterLink, {
                      class: "btn btn-sm btn-primary",
                      title: "Ler o contrato",
                      target: "_blank",
                      to: { name: 'planosLer', params: { id: _unref(controle).model.planoId } }
                    }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createElementVNode("i", { class: "flaticon-search" }, null, -1),
                        _createTextVNode(" Ler o contrato ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).model.plano)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col-md-3" }, " Idade Mínima ", -1)),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(TextBox, {
                        "model-value": _unref(controle).model.plano.idadeMinima,
                        readonly: "",
                        disabled: "",
                        class: "text-end"
                      }, null, 8, ["model-value"])
                    ]),
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col-md-2" }, " Idade Máxima ", -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(TextBox, {
                        "model-value": _unref(controle).model.plano.idadeMaxima,
                        readonly: "",
                        disabled: "",
                        class: "text-end"
                      }, null, 8, ["model-value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-md-3" }, " Máximo de Pessoas ", -1)),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(TextBox, {
                        "model-value": _unref(controle).model.plano.maximoPessoas,
                        readonly: "",
                        disabled: "",
                        class: "text-end"
                      }, null, 8, ["model-value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "col-md-3" }, " Valor R$ ", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(TextBox, {
                        "model-value": _unref(controle).model.plano.valor,
                        formato: 'DoisDecimais',
                        readonly: "",
                        disabled: "",
                        class: "text-end"
                      }, null, 8, ["model-value"])
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "col-md-2" }, " Valor com Seguro R$ ", -1)),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(TextBox, {
                        "model-value": _unref(controle).model.plano.valorComSeguro,
                        formato: 'DoisDecimais',
                        readonly: "",
                        disabled: "",
                        class: "text-end"
                      }, null, 8, ["model-value"])
                    ])
                  ]),
                  (_unref(controle).model.plano.permiteSeguro)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-md-3" }, " Com Seguro? ", -1)),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(DropdownSimNao, {
                            modelValue: _unref(controle).model.comSeguro,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.comSeguro) = $event)),
                            class: "form-select form-select-sm"
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-md-3" }, " Vendedor ", -1)),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(DropdownVendedores, {
                  modelValue: _unref(controle).model.vendedorId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.vendedorId) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model?.contratoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-3" }, " Status ", -1)),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(DropdownContratosStatus, {
                      modelValue: _unref(controle).model.statusId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.statusId) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).model?.contratoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _cache[53] || (_cache[53] = _createElementVNode("div", { class: "col-md-3" }, " Dt Inicio ", -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      value: _unref(fdataUS)(_unref(controle).model.dataInicio),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(controle).model.dataInicio = $event.target.value))
                    }, null, 40, _hoisted_45)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).model?.contratoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _cache[54] || (_cache[54] = _createElementVNode("div", { class: "col-md-3" }, " Dt Fim ", -1)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      value: _unref(fdataUS)(_unref(controle).model.dataFim),
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (_unref(controle).model.dataFim = $event.target.value))
                    }, null, 40, _hoisted_48)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["exibir"])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janPerguntaContrato',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[11] || (_cache[11] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[12] || (_cache[12] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"]),
    _createVNode(MsgBox, {
      id: 'janParcelas',
      tamanho: "modal-lg",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janParcelas,
      titulo: 'Parcelas do Contrato ' + (_unref(controle).contratoParcelas?.contratoId ?? ''),
      onOnFechou: _cache[19] || (_cache[19] = ($event: any) => {_unref(controle).janParcelas = false; _unref(controle).parcelaEditando = null}),
      "botao-fechar": true
    }, {
      default: _withCtx(() => [
        (_unref(controle).parcelaEditando == null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(controle).contratoParcelas?.statusId != 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("a", {
                        class: "btn btn-sm btn-success",
                        href: "#",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (abrirGerarParcelas()), ["prevent"]))
                      }, [...(_cache[56] || (_cache[56] = [
                        _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                        _createTextVNode(" Gerar Parcelas ", -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("table", _hoisted_52, [
                  _cache[63] || (_cache[63] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Parcela"),
                      _createElementVNode("th", null, "Referente"),
                      _createElementVNode("th", null, "Vencimento"),
                      _createElementVNode("th", null, "Valor"),
                      _createElementVNode("th", null, "Pagamento"),
                      _createElementVNode("th", null, "Valor Pago"),
                      _createElementVNode("th", null, "Boleto"),
                      _createElementVNode("th", null, "Ações")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_unref(controle).parcelas.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [...(_cache[57] || (_cache[57] = [
                          _createElementVNode("td", {
                            colspan: "8",
                            class: "text-center"
                          }, "Nenhuma parcela encontrada", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).parcelas, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.parcela), 1),
                        _createElementVNode("td", null, _toDisplayString(item.referente), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataVencimento)), 1),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(_unref(f2dec)(item.valor)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataPagamento)), 1),
                        _createElementVNode("td", _hoisted_55, _toDisplayString(_unref(f2dec)(item.valorPago)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.boletoId ?? '-'), 1),
                        (item.statusId == 6)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_56, [...(_cache[58] || (_cache[58] = [
                              _createElementVNode("span", { class: "badge bg-secondary" }, "Cancelada", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_57, [
                              (item.boletoId == null && item.dataPagamento == null)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "btn btn-sm btn-primary me-1",
                                    title: "Alterar parcela",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (editarParcela(item)), ["prevent"])
                                  }, [...(_cache[59] || (_cache[59] = [
                                    _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                                  ]))], 8, _hoisted_58))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "text-muted me-1",
                                    title: item.dataPagamento != null ? 'Parcela já paga, não é possível alterar' : 'Parcela já tem boleto gerado, não é possível alterar'
                                  }, [...(_cache[60] || (_cache[60] = [
                                    _createElementVNode("i", { class: "flaticon-lock" }, null, -1)
                                  ]))], 8, _hoisted_59)),
                              (item.boletoId != null)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    class: "btn btn-sm btn-warning me-1",
                                    title: "Imprimir boleto",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (abrirBoleto(item.boletoId)), ["prevent"])
                                  }, [...(_cache[61] || (_cache[61] = [
                                    _createElementVNode("i", { class: "fa fa-print" }, null, -1)
                                  ]))], 8, _hoisted_60))
                                : _createCommentVNode("", true),
                              (item.dataPagamento == null)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 3,
                                    class: "btn btn-sm btn-success",
                                    title: "Pagar",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (confirmarPagamento(item)), ["prevent"])
                                  }, [...(_cache[62] || (_cache[62] = [
                                    _createElementVNode("i", { class: "fa fa-check" }, null, -1),
                                    _createTextVNode(" Pagar ", -1)
                                  ]))], 8, _hoisted_61))
                                : _createCommentVNode("", true)
                            ]))
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(controle).statusParcelas), 1),
                _createElementVNode("span", _hoisted_64, _toDisplayString(_unref(controle).erroParcelas), 1)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, " Parcela " + _toDisplayString(_unref(controle).parcelaEditando.parcela), 1)
              ]),
              _createElementVNode("div", _hoisted_67, [
                _cache[64] || (_cache[64] = _createElementVNode("div", { class: "col-md-3" }, " Vencimento ", -1)),
                _createElementVNode("div", _hoisted_68, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(controle).formParcela.dataVencimento) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(controle).formParcela.dataVencimento]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "col-md-3" }, " Valor R$ ", -1)),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(TextBox, {
                    modelValue: _unref(controle).formParcela.valor,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(controle).formParcela.valor) = $event)),
                    formato: 'DoisDecimais',
                    class: "text-end"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-md-3" }, " Referente ", -1)),
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(TextBox, {
                    modelValue: _unref(controle).formParcela.referente,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(controle).formParcela.referente) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(controle).statusEdicaoParcela), 1),
                  _createElementVNode("span", _hoisted_76, _toDisplayString(_unref(controle).erroEdicaoParcela), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("a", {
                    class: "btn btn-sm btn-primary me-2",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (salvarParcela()))
                  }, [...(_cache[67] || (_cache[67] = [
                    _createElementVNode("i", { class: "fa fa-save" }, null, -1),
                    _createTextVNode(" Gravar ", -1)
                  ]))]),
                  _createElementVNode("a", {
                    class: "btn btn-sm btn-secondary",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (cancelarEdicaoParcela()))
                  }, [...(_cache[68] || (_cache[68] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                    _createTextVNode(" Cancelar ", -1)
                  ]))])
                ])
              ])
            ], 64))
      ]),
      _: 1
    }, 8, ["exibir", "titulo"]),
    _createVNode(MsgBox, {
      id: 'janCancelarContrato',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janCancelarContrato,
      titulo: 'Cancelar contrato ' + (_unref(controle).contratoCancelando?.contratoId ?? ''),
      onOnFechou: _cache[21] || (_cache[21] = ($event: any) => (_unref(controle).janCancelarContrato = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[22] || (_cache[22] = ($event: any) => (cancelarContratoConfirmado()))
    }, {
      default: _withCtx(() => [
        _cache[70] || (_cache[70] = _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fw-bold text-center" }, " Deseja cancelar este contrato? ")
        ], -1)),
        _cache[71] || (_cache[71] = _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 small text-muted" }, " As parcelas em aberto serão canceladas e não serão mais geradas parcelas nem boletos. Parcelas pagas e parcelas com boleto já enviado/registrado no banco são mantidas. ")
        ], -1)),
        _createElementVNode("div", _hoisted_79, [
          _cache[69] || (_cache[69] = _createElementVNode("div", { class: "col-md-3" }, " Motivo ", -1)),
          _createElementVNode("div", _hoisted_80, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control form-control-sm",
              rows: "3",
              maxlength: "500",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(controle).motivoCancelamento) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).motivoCancelamento]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(controle).statusCancelamento), 1),
            _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(controle).erroCancelamento), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir", "titulo"]),
    _createVNode(MsgBox, {
      id: 'janGerarParcelas',
      tamanho: "modal-lg",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janGerarParcelas,
      titulo: 'Gerar Parcelas',
      onOnFechou: _cache[27] || (_cache[27] = ($event: any) => {_unref(controle).janGerarParcelas = false; _unref(controle).parcelasSimuladas = []}),
      "botao-fechar": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_85, [
          _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-md-3" }, " Data Inicial ", -1)),
          _createElementVNode("div", _hoisted_86, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(controle).formGerarParcelas.dataInicial) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formGerarParcelas.dataInicial]
            ])
          ]),
          _cache[73] || (_cache[73] = _createElementVNode("div", { class: "col-md-2" }, " Data Final ", -1)),
          _createElementVNode("div", _hoisted_87, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(controle).formGerarParcelas.dataFinal) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formGerarParcelas.dataFinal]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("a", {
              class: "btn btn-sm btn-primary",
              href: "#",
              onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (verParcelasSimuladas()), ["prevent"]))
            }, [...(_cache[74] || (_cache[74] = [
              _createElementVNode("i", { class: "fa fa-search" }, null, -1),
              _createTextVNode(" Ver ", -1)
            ]))])
          ])
        ]),
        (_unref(controle).parcelasSimuladas.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("table", _hoisted_92, [
                  _cache[75] || (_cache[75] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Parcela"),
                      _createElementVNode("th", null, "Data Vencimento"),
                      _createElementVNode("th", null, "Valor")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).parcelasSimuladas, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.parcela), 1),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((item.dataVencimento) = $event)
                          }, null, 8, _hoisted_93), [
                            [_vModelText, item.dataVencimento]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_94, _toDisplayString(_unref(f2dec)(item.valor)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("span", _hoisted_97, _toDisplayString(_unref(controle).statusGerarParcelas), 1),
            _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(controle).erroGerarParcelas), 1)
          ])
        ]),
        (_unref(controle).parcelasSimuladas.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-success",
                  href: "#",
                  onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (gerarParcelasConfirmado()), ["prevent"]))
                }, [
                  _cache[76] || (_cache[76] = _createElementVNode("i", { class: "fa fa-save" }, null, -1)),
                  _createTextVNode(" Gerar " + _toDisplayString(_unref(controle).parcelasSimuladas.length) + " Parcela(s) ", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["exibir"]),
    _createVNode(MsgBox, {
      id: 'janConfirmaPagamentoParcela',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janConfirmaPagamento,
      titulo: 'Atenção',
      onOnFechou: _cache[28] || (_cache[28] = ($event: any) => {_unref(controle).janConfirmaPagamento = false; _unref(controle).parcelaPagando = null}),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[29] || (_cache[29] = ($event: any) => (pagarConfirmado()))
    }, {
      default: _withCtx(() => [
        _cache[77] || (_cache[77] = _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Confirma o pagamento? ")
        ], -1)),
        (_unref(controle).parcelaPagando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, " Parcela " + _toDisplayString(_unref(controle).parcelaPagando.parcela) + " - R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).parcelaPagando.valor)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("span", _hoisted_105, _toDisplayString(_unref(controle).statusPagamento), 1),
            _createElementVNode("span", _hoisted_106, _toDisplayString(_unref(controle).erroPagamento), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})